import React from "react";
import { useInterfaceAccess } from "../../hooks/useInterfaceAccess";
import AbScreenShell from "./AbScreenShell";
import Banner from "./shared/Banner";
import { AB_VAULT_INTERFACE_ID, type VaultTool } from "./config";
import { useVaultTools } from "./useVaultTools";

const DENIED =
  "You don't have access to this Vault tool. Ask your admin to add you to its access team.";

/**
 * Keeps a Vault screen from mounting (and calling its API) for a user who may not use that tool,
 * showing a notice under the normal header instead. Anything it can't decide (interface not
 * enabled, session expired, user info failing) is left to the screen's own notice, and the API
 * enforces the same rule regardless.
 */
const VaultToolGate = ({
  tool,
  children,
}: {
  tool: VaultTool;
  children: React.ReactNode;
}) => {
  const access = useInterfaceAccess(AB_VAULT_INTERFACE_ID);
  const tools = useVaultTools();
  if (
    access.status === "pending" ||
    (access.status === "granted" && tools.status === "pending")
  ) {
    return <AbScreenShell loading>{null}</AbScreenShell>;
  }
  if (tools.status === "ready" && !tools.tools.includes(tool)) {
    return (
      <AbScreenShell notice={<Banner error={DENIED} />}>{null}</AbScreenShell>
    );
  }
  return <>{children}</>;
};

export default VaultToolGate;
